import hash from 'object-hash';
import { CardData, CardId, DeckData, DeckId, ProjectFont, ProjectMappings, ProjectPanel, ProjectReplacements } from './project-types.ts';
import { normalizeString } from './utils.ts';
import { BoardData } from './board/board-types.ts';
import { DEFAULT_BOARD_DATA } from './board/board-constants.ts';

export class Project {
    spreadsheetId: string;
    title: string;
    cardSheets: string[] = [];
    boardSheets: string[] = [];
    font: ProjectFont = { name: 'Arial', color: 'black' };
    panels: ProjectPanel[] = [];
    mappings: ProjectMappings = {};
    replacements: ProjectReplacements = {};
    cards: CardData[] = [];
    decks: DeckData[] = [];
    board: BoardData = structuredClone(DEFAULT_BOARD_DATA);

    constructor(spreaadsheetId: string, title: string) {
        this.spreadsheetId = spreaadsheetId;
        this.title = title;
    }

    getCardImages(): HTMLCanvasElement[] {
        return this.cards.map(card => card.image).filter(image => !!image);
    }

    getCardsWithImage(): (CardData & { imageId: string; image: HTMLCanvasElement; })[] {
        return this.cards.filter(card => !!card.imageId) as (CardData & { imageId: string; image: HTMLCanvasElement; })[];
    }

    getCardById(cardId: CardId): CardData | undefined {
        return this.cards.find(card => card.id === cardId);
    }

    getDeckById(deckId: DeckId): DeckData | undefined {
        return this.decks.find(deck => deck.id === deckId);
    }

    getOrCreateDeck(deckName: string) {
        let deckId = normalizeString(deckName);
        let deck = this.getDeckById(deckId);

        if (!deck) {
            deck = {
                id: deckId,
                name: deckName,
                cardIds: [],
            };
            this.decks.push(deck);
        }

        return deck;
    }

    getHash(): string {
        return hash(this, {
            respectType: false,
            replacer: (value: any) => {
                if (value && value instanceof Element) {
                    return null;
                } else {
                    return value;
                }
            }
        });
    }
}